import { AppContext } from '../../context';
import './CancelLink.css';
import { abortCardPayment } from '../../lib/epayment';
import React, { useContext } from 'react';

export const CancelLink = ({
  children,
  returnUrl,
  setErrorMessage,
}: {
  children: React.ReactNode;
  returnUrl: string;
  setErrorMessage: React.Dispatch<React.SetStateAction<string | null>>;
}) => {
  const context = useContext(AppContext);
  const abortPayment = async () => {
    try {
      const response = await abortCardPayment(context);

      if (response?.status == 202) {
        window.location.assign(returnUrl);
      }
    } catch (e) {
      if (e instanceof Response) {
        if (e.status == 400) {
          setErrorMessage(context.texts.abortFailed);
          return;
        }
      }
      setErrorMessage(context.texts['error.message.unknown']);
    }
  };

  return (
    <a className="cancel-link" onClick={abortPayment}>
      {children}
    </a>
  );
};
